import { useMemo } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { PopoverModal } from "../../../components/popoverModal/PopoverModal";
import SimplePopoverOption from "../../../components/popoverModal/SimplePopoverOption";
import { useActions } from "./useActions";
import { CustomChip } from "../../../components/chip/Chip";
import { colorEstadosChip } from "../constants/colorEstados";

export const useGetColumns = (
    misVisitas = true,
    handleClickView,
    handleClickEdit,
    handleClickDelete
) => {

    const actionsColumn = {
        headerName: "",
        field: "action",
        flex: 30,
        minWidth: 35,
        noPadding: true,
        sortable: false,
        align: "center",
        renderCell: (cellProps) => {
            const { row } = cellProps;
            return (
                <PopoverModal>
                    <div className="popover-modal-content" style={{ marginTop: '5px' }}>

                        {row?.estado == 'Incompleta' && <SimplePopoverOption
                            onClick={() => handleClickEdit(row)}
                            Icon={EditIcon}
                            label="Editar"
                        />}
                        <SimplePopoverOption
                            onClick={() => handleClickView(row)}
                            Icon={VisibilityIcon}
                            label="Ver"
                        />
                        {row?.estado == 'Incompleta' && <SimplePopoverOption
                            onClick={() => handleClickDelete(row)}
                            Icon={DeleteOutlineIcon}
                            label="Eliminar"
                        />}
                    </div>
                </PopoverModal>
            );
        },
    };

    const initialColumns = [
        actionsColumn,
        // La columna idVisita es funcional, se oculta para el producto final pero los desarrolladores 
        // pueden descomentarlo para su uso
        {
            flex: 30,
            minWidth: 40,
            field: 'idVisita',
            headerName: '#',
            noPadding: true
        },
        {
            flex: 90,
            field: 'fechaVisita',
            headerName: 'F. Visita',
            type: 'date'
        },
        {
            flex: 90,
            field: 'tipoVisita',
            headerName: 'Tipo'
        },
        {
            flex: 100,
            field: 'estado',
            headerName: 'Estado',
            renderCell: ({ row }) => {
                const color = colorEstadosChip[row?.estado];
                return (row?.estado
                    ? <CustomChip label={row?.estado} {...color} />
                    : <div className='center'>-</div>)
            }
        },
    ];

    const initialColumnsLite = [
        {
            headerName: "",
            field: "action",
            minWidth: 45,
            flex: 1,
            sortable: false,
            noPadding: true,
            align: "center",
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (<IconButton onClick={() => handleClickView(row)}>
                    <VisibilityIcon />
                </IconButton>);
            }
        },
        {
            flex: 50,
            field: 'idVisita',
            headerName: '#'
        },
        {
            flex: 150,
            field: 'fechaVisita',
            headerName: 'F. Visita',
            type: 'date'
        }
    ];

    const columnsFiltered = useMemo(() => {
        return misVisitas ? initialColumns : initialColumnsLite;
    }, [misVisitas]);


    const columns = useMemo(() => generateColumnsDefaultConfiguration(columnsFiltered, true), [columnsFiltered]);

    return columns;
}


